import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4caf2e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table",
  style: {"max-height":"100%"}
}

import { PropType, watchEffect } from "vue";
import { SearchDataAnalysis } from "@/interface/search.data";
import Loading from "vue3-loading-overlay";
import { userUseStore } from "@/store/user";
// import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  headers: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  items: {
    type: Array as PropType<SearchDataAnalysis[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props

const userStore = userUseStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Loading), {
      active: _unref(userStore).isLoading,
      "is-full-page": false,
      "background-color": "#2b323a",
      color: "#8c98a5",
      opacity: 0.8
    }, null, 8, ["active", "opacity"]),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (val, idx) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "search-th",
              scope: "col",
              key: idx
            }, _toDisplayString(val), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (val, idx) => {
          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val, (val2, idx2) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "search-td",
                key: idx2
              }, _toDisplayString(val2), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})